(function () {
  function getReportItems(container) {
    if (!container) return [];

    return Array.from(
      container.querySelectorAll(
        '.trust-assurance-grid__footer > p, .trust-assurance-grid__footer li'
      )
    ).filter(function (item) {
      return item.textContent.trim() !== '';
    });
  }

  function updateToggleLabel(toggle, hiddenCount, showMoreLabel, showLessLabel, expanded) {
    if (!toggle) return;

    if (expanded) {
      toggle.textContent = showLessLabel;
      return;
    }

    toggle.textContent = hiddenCount > 0 ? showMoreLabel + ' ' + hiddenCount + ' more' : showMoreLabel;
  }

  function initTrustAssuranceGrid(section) {
    if (!section || section.dataset.reportsReady === 'true') return;

    var reports = section.querySelector('.trust-assurance-grid__reports');
    var toggle = section.querySelector('.trust-assurance-grid__reports-toggle');

    if (!reports || !toggle) {
      section.dataset.reportsReady = 'true';
      return;
    }

    var initialVisible = 3;
    var showMoreLabel = reports.dataset.showMoreLabel || 'Show';
    var showLessLabel = reports.dataset.showLessLabel || 'Show less';
    var items = getReportItems(reports);

    if (!initialVisible || items.length <= initialVisible) {
      toggle.hidden = true;
      section.dataset.reportsReady = 'true';
      return;
    }

    var expanded = false;

    function render() {
      items.forEach(function (item, index) {
        item.hidden = !expanded && index >= initialVisible;
      });

      updateToggleLabel(toggle, Math.max(items.length - initialVisible, 0), showMoreLabel, showLessLabel, expanded);
      toggle.hidden = false;
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    toggle.addEventListener('click', function () {
      expanded = !expanded;
      render();
    });

    render();
    section.dataset.reportsReady = 'true';
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.trust-assurance-grid').forEach(initTrustAssuranceGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
